import { render, staticRenderFns } from "./banner-add-edit.vue?vue&type=template&id=280c8dd4&scoped=true&"
import script from "./banner-add-edit.vue?vue&type=script&lang=ts&"
export * from "./banner-add-edit.vue?vue&type=script&lang=ts&"
import style0 from "./banner-add-edit.vue?vue&type=style&index=0&id=280c8dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c8dd4",
  null
  
)

export default component.exports